import React from 'react';

import { Stack, Title, Text, useMantineTheme } from '@mantine/core';
import { IconFlask } from '@tabler/icons-react';

import CreateDemoGymButtonMenu from './CreateDemoGymButtonMenu';

const DemoGymTableEmptyState = (): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Stack align='center' spacing='xs' my='xl'>
      <IconFlask color={theme.colors.red[5]} />
      <Title order={2}>No Demo Gyms Yet!</Title>
      <Text size='xl'>Let’s get started with your first demo</Text>
      <Text size='xl' mb='xl' color='gray'>
        Create a personalized demo Gym account for your prospect in just a few clicks!
      </Text>

      <CreateDemoGymButtonMenu />
    </Stack>
  );
};

export default DemoGymTableEmptyState;
